module.exports = __webpack_public_path__ + "img/success.9cdb298d.png";